import React, {useEffect} from "react";
import modalDrag from '../hooks/modalDrag'

import '../design/styles/modal.css'

const Modal = ({children, title, modalClose, modalId, Alert, width = '90%'}) => {

  useEffect(() => { 

    if (!modalId) return Alert({msg: 'No se indico un ID para la ventana modal'})
    modalDrag(document.getElementById(modalId))

  } ,[Alert, modalId])

  const clickCerrar = (e) => {
    modalClose(false)
  }

  return (
    <>
      
       { modalId &&
          <div>
            <div className="modal" style={{ '--modal-width': width }} id={modalId}>
               <div className="modal-header">
                 <h3>{title}</h3>
                  <button
                    type="button"
                    onClick={clickCerrar}
                    className="Modal-close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </button>
               </div>
               <div className="modal-body">
                 {children}
               </div>
             </div>
           <div className="overlay"></div>
          </div>
       } 
    </>
  )
}

export default Modal